import { z } from 'zod';

/**
 * Validation schema for profile info form
 * - name: Required field with minimum 1 character
 */
export const profileInfoSchema = z.object({
  name: z.string().min(1, 'common:error.required'),
});

export type ProfileInfoFormData = z.infer<typeof profileInfoSchema>;
